module.exports = __webpack_public_path__ + "static/img/case_detail_02_1.d5458ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_02_1.png
// module id = R4A6
// module chunks = 34